/**
 * MailFeatureGuard (OCP-212) — wraps a Mail-feature route so that
 * SaaS-tenant-only customers (no explicit OMS subscription) get
 * redirected to /mail with a brief banner instead of rendering the
 * gated page (API keys, Domains, Webhooks, Templates, Settings,
 * Connections).
 *
 * Loading + error states fall through to children — the API guard
 * is the authoritative gate; this is a UX layer that prevents the
 * "I'm on /mail/api-keys but the API rejects every action" loop.
 */
import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';

import { useHasOmsSubscription } from '../lib/use-has-oms-subscription';

export function MailFeatureGuard({ children }: { children: ReactNode }) {
  const { loading, hasOms, error } = useHasOmsSubscription();
  if (loading || error !== null) return <>{children}</>;
  if (hasOms === false) {
    return <Navigate to="/mail?reason=oms-sub-required" replace />;
  }
  return <>{children}</>;
}
